
<div class="flex min-h-80 bg-white border-solid border-1 border-grey-divider-subdued rounded-xl text-left">
  <slot></slot>
  <div class="my-16">
    <p class="text-strong-body">{{ title }}</p>
    <p class="text-small">{{ body }}</p>
  </div>
</div>
